export const EnvSelector = {
	env: 'stage'
};